// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminPaymentCustomerResponse

export type AdminPaymentCustomerApiResponse = {
	id: string;
	firstname: string;
	lastname: string;
	email: string;
};

export type AdminPaymentCustomer = {
	id: string;
	firstname: string;
	lastname: string;
	email: string;
};

export function hydrateAdminPaymentCustomer(data: AdminPaymentCustomerApiResponse): AdminPaymentCustomer {
	return { ...data };
}